<template>
  <div class="season">
    <div class="season-nav">
      <div class="control">
        <div class="control-search">
          <span>赛季名称：</span>
          <div class="search-input">
            <el-input
              size="small"
              type="text"
              v-model="name"
              placeholder="请输入赛季名称"
            ></el-input>
          </div>
          <el-button
            size="small"
            type="primary"
            class="search-but1"
            @click="handleSearch"
          >
            查询
          </el-button>
          <el-button size="small" @click="handleReset">重置</el-button>
        </div>

        <div>
          <el-button
            class="control-add"
            size="small"
            type="primary"
            @click="openDialog('add')"
          >
            添加
          </el-button>
        </div>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="dataSource"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
        >
          <template slot-scope="scope">
            {{ tableTranslation(item.prop, scope.row) }}
          </template>
        </el-table-column>

        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="80"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('editor', scope.row)">
              编辑
            </el-button>
            <el-button type="text" @click="handleDel(scope.row)">
              删除.
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <user-dialog
      v-if="dialogFlag"
      :openType="dialogType"
      :defaultData="dialogData"
      :handleClose="handleDialogClose"
    />
  </div>
</template>
<script>
import { seasonColumn, translationSeasonStatus } from "./components/assets";
import * as API from "@/api/season/vip.js";
import UserDialog from "./components/seasonDialog.vue";
import dayjs from "dayjs";

export default {
  name: "Season",
  components: {
    ["user-dialog"]: UserDialog,
  },
  data() {
    return {
      tableColumn: seasonColumn,
      name: "",
      dataSource: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false,
      dialogFlag: false,
      dialogData: {},
      dialogType: null,
    };
  },
  created() {
    this.getDataSource();
  },
  methods: {
    handleSearch() {
      this.page = 1;
      this.getDataSource();
    },
    handleReset() {
      this.name = "";
      this.page = 1;
      this.getDataSource();
    },
    async getDataSource() {
      this.loading = true;
      const { name, page, limit } = this;
      const params = {
        name,
        page: String(page),
        limit: String(limit),
      };
      try {
        const res = await API.getSeasonList(params);
        const { code, data } = res;
        if (code === 0 && data) {
          const { total, records = [] } = data;
          this.total = Number(total);
          this.dataSource = records ?? [];
        }
      } catch (error) {
        this.dataSource = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleLimitChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.getDataSource();
    },
    handlePageChange(page) {
      this.page = page;
      this.getDataSource();
    },
    handleDel(rowData) {
      const { beginDate } = rowData;
      const canDel = dayjs().valueOf() < dayjs(beginDate).valueOf();
      if (canDel) {
        this.$confirm("确定要删除吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async () => {
            try {
              const res = await API.delSeason({}, rowData.id);
              const { code } = res;
              if (code === 0) {
                this.$message.success("删除成功！");
                this.getDataSource();
              }
            } catch (error) {
              //防止request返回reject
            }
          })
          .catch(() => {});
      } else {
        this.$confirm("当前赛季已开始或已结束，不可删除！", {
          confirmButtonText: "确定",
          showCancelButton: false,
        });
      }
    },
    openDialog(type, rowData = {}) {
      this.dialogType = type;
      this.dialogData = rowData;
      this.dialogFlag = true;
    },
    handleDialogClose(isReset) {
      this.dialogFlag = false;
      //新增从第一页请求，编辑保留当前搜索项
      switch (isReset) {
        case 0:
          break;
        case 1:
          this.handleReset();
          break;
        case 2:
          this.getDataSource();
          break;
        default:
          break;
      }
    },
    tableTranslation(prop, rowData) {
      const { beginDate, endDate } = rowData;
      switch (prop) {
        case "seasonCycle":
          return beginDate + " - " + endDate;
        case "status":
          return rowData.status === 1 ? '未开始' : rowData.status === 2 ? '进行中' : rowData.status === 3 ? '已结束' : '';
        default:
          return rowData[prop];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.season {
  .season-nav {
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    .control {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .control-search {
        display: flex;
        align-items: center;
        .search-input {
          margin-right: 20px;
        }
        .search-but1 {
          margin-right: 10px;
        }
      }
    }
  }
  .table {
    margin-bottom: 20px;
  }
  .pagination {
    text-align: right;
  }
}
</style>
